import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  isEmpty,
  isEqual,
} from 'lodash';
import {
  ImportLocationsActions,
  VibeDialog,
} from 'vibeguide';
import ImportHeader from './ImportHeader';
import ImportBulkInformation from './ImportBulkInformation';
import ImportFile from './ImportFile';
import ImportFields from './ImportFields';
import './ImportLocations.scss';
// import { setMediaFormat } from '../../../../../../vibeguide/src/actions/Import/ImportLocationsActions';

class ImportLocations extends PureComponent {
  componentDidUpdate(prevProps) {
    const {
      mediaFormat,
      setData,
    } = this.props;

    const {
      mediaFormat: prevMediaFormat,
    } = prevProps;

    if (!isEqual(mediaFormat, prevMediaFormat) && !isEmpty(prevMediaFormat)) {
      setData({
        status: null,
        rowCount: 0,
        sets: {},
        dataUrl: null,
        validationResult: {},
      });
    }
  }

  componentWillUnmount() {
    const {
      resetImportLocations,
    } = this.props;

    resetImportLocations();
  }

  render() {
    const {
      mediaFormat,
    } = this.props;

    return (
      <VibeDialog
        title="Import Locations"
        closeDialogLink="/locations"
        open
        fullScreen
      >
        <div className="ImportLocations">
          <PerfectScrollbar>
            <ImportHeader />

            <div className="import-content">
              <div className="left-col">
                <ImportBulkInformation />
              </div>

              <div className="right-col">
                <ImportFile
                  mediaFormat={mediaFormat}
                />
                {!isEmpty(mediaFormat)
                  ? (
                    <ImportFields
                      mediaFormat={mediaFormat}
                    />
                  ) : (
                    <div className="empty-media-format">Select a media format to view import template</div>
                  )}
              </div>
            </div>
          </PerfectScrollbar>
        </div>
      </VibeDialog>
    );
  }
}

function mapStateToProps(state) {
  return {
    mediaFormat: state.import.locations.mediaFormat,
  };
}

const mapDispatchToProps = {
  resetImportLocations: ImportLocationsActions.resetImportLocations,
  mediaFormat: ImportLocationsActions.mediaFormat,
  setData: ImportLocationsActions.setData,
  setBulkInformationConfirmed: ImportLocationsActions.setBulkInformationConfirmed,
};

export default connect(mapStateToProps, mapDispatchToProps)(ImportLocations);
